import script from "./TagsListChecker.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsListChecker.vue?vue&type=script&setup=true&lang=js"

import "./TagsListChecker.vue?vue&type=style&index=0&id=d64b7402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d64b7402"]])

export default __exports__